import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './Login';
import Home from './Home';
import ProtectedRoute from './ProtectedRoute';
import AggiungiQuadro from './AggiungiQuadro';
import VisualizzaQuadro from './VisualizzaQuadro';
import CreaFiera from "./CreaFiera";
import GestisciFiera from "./GestisciFiera";
import DettagliFiera from "./DettagliFiera";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
        <Route path="/aggiungi" element={<ProtectedRoute><AggiungiQuadro /></ProtectedRoute>} />
        <Route path="/visualizza" element={<ProtectedRoute><VisualizzaQuadro /></ProtectedRoute>} />
        <Route path="/crea" element={<ProtectedRoute><CreaFiera /></ProtectedRoute>} />
        <Route path="/gestisci" element={<ProtectedRoute><GestisciFiera /></ProtectedRoute>} />
        <Route path="/fiera/:id" element={<DettagliFiera />} />
      </Routes>
    </Router>
  );
}

export default App;
